const SHORTCUTS = [
  { key: 'Space', desc: 'Open Eyedropper' },
  { key: 'C', desc: 'Copy HEX' },
  { key: 'X', desc: 'Random Color' },
  { key: 'Esc', desc: 'Close picker' },
];

export function showShortcuts(): void {
  // 移除已存在的
  const existing = document.querySelector('.help-modal');
  if (existing) existing.remove();

  const overlay = document.createElement('div');
  overlay.className = 'help-modal';

  const card = document.createElement('div');
  card.className = 'help-modal__card';

  const title = document.createElement('h2');
  title.className = 'help-modal__title';
  title.textContent = 'Keyboard Shortcuts';

  const close = document.createElement('button');
  close.className = 'help-modal__close';
  close.innerHTML = '&times;';
  close.setAttribute('aria-label', 'Close');
  close.addEventListener('click', () => overlay.remove());

  const list = document.createElement('ul');
  list.className = 'help-modal__list';
  for (const s of SHORTCUTS) {
    const li = document.createElement('li');
    li.className = 'help-modal__item';

    const kbd = document.createElement('kbd');
    kbd.className = 'help-modal__key';
    kbd.textContent = s.key;

    const span = document.createElement('span');
    span.className = 'help-modal__desc';
    span.textContent = s.desc;

    li.append(kbd, span);
    list.appendChild(li);
  }

  card.append(title, close, list);
  overlay.appendChild(card);
  document.body.appendChild(overlay);

  // Focus trap
  close.focus();

  // 点击外部关闭
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) overlay.remove();
  });

  // ESC 关闭
  const onKey = (e: KeyboardEvent) => {
    if (e.key === 'Escape') {
      overlay.remove();
      document.removeEventListener('keydown', onKey);
    }
  };
  document.addEventListener('keydown', onKey);
}
